import request from '@/utils/request';

//个性化短链列表
export function getLinkList(values) {
  return request('/sms/queryLinkList', {
    method: 'POST',
    data: values,
  });
}
//个性化短链审核
export function approveLink(values) {
  return request('/sms/approveLink', {
    method: 'POST',
    data: values,
  });
}
